import apiRequest from "./axiosInstance";

/**
 * Registers a new user
 * @param {Object} data - User registration data
 * @returns {Promise<Object>} Response object from the API request
 */
export const register = (data) => apiRequest("post", "/auth/register", data);

/**
 * Logs in a user
 * @param {Object} data - User login credentials
 * @returns {Promise<Object>} Response object from the API request
 */
export const login = (data) =>
  apiRequest("POST", "/auth/login", data, {}, {}, false, "Yes");

export const loginSSO = () => apiRequest("GET", "/login");

export const logoutSSO = () => apiRequest("GET", "/logout");

export const TokenExpired = () => apiRequest("GET", "/auth/expired");

/**
 * Authentication API service module
 * @module
 */
